import { useEffect } from 'react';
import { useFormikContext } from 'formik';

import { formatPrice } from 'utils/helpers';
import {
  List,
  Flex,
  ListCard,
  Checkbox,
  ListHeader,
  InputField,
  ErrorMessage,
} from 'components';

import { FormValues, ProductsProps, HandleProductChange } from './types';

const titles = ['Product', 'Quantity', 'Price'];

export const Products = ({
  opened,
  cartData,
  isInitialize,
  setInitialize,
}: ProductsProps) => {
  const currentCartItems = cartData?.items?.filter((item) => !item.isExchange);
  const { values, errors, setFieldValue } = useFormikContext<FormValues>();

  const handleProductChange = ({ item, checked }: HandleProductChange) => {
    const id = item.id;
    const updatedProducts = checked
      ? [
          ...values.products,
          {
            id,
            name: item?.product?.name,
            productId: item?.product?.id,
            quantity: item?.quantity || 1,
            price: item?.product?.retailPrice,
            photoUrl: item?.product?.photoUrl,
          },
        ]
      : values?.products?.filter((product) => product.id !== id);
    setFieldValue('products', updatedProducts);
  };

  useEffect(() => {
    if (!isInitialize && opened && cartData?.items) {
      const cartItems =
        currentCartItems?.map((item) => ({
          id: item.id,
          price: item.price,
          quantity: item.quantity,
          productId: item.productId,
          name: item?.product?.name,
          photoUrl: item?.product?.photoUrl,
        })) || [];

      setFieldValue('products', cartItems);
      setInitialize(true);
    }
  }, [opened, isInitialize, cartData?.items, setFieldValue, setInitialize]);

  return (
    <Flex gap={24} fullWidth flexDirection="column">
      {errors.products && typeof errors?.products === 'string' && (
        <ErrorMessage>{errors.products}</ErrorMessage>
      )}

      <List
        count={currentCartItems?.length}
        mainWrapperStyles={{ padding: 0, overflow: 'unset' }}
        header={<ListHeader titles={titles} padding="8px 16px" />}
      >
        {currentCartItems?.map((item) => {
          const productIndex = values?.products?.findIndex(
            (product) => product?.id === item?.id
          );
          const isChecked = productIndex !== -1;

          return (
            <ListCard
              key={item?.id}
              headers={titles}
              values={[
                <Flex gap={16}>
                  <Checkbox
                    checked={isChecked}
                    disabled={item.isProductOutStorage}
                    onChange={() =>
                      handleProductChange({ item, checked: !isChecked })
                    }
                  />
                  <p>{item?.product?.name}</p>
                </Flex>,
                isChecked ? (
                  <InputField
                    number
                    decimal
                    placeholder="Quantity"
                    name={`products.${productIndex}.quantity`}
                  />
                ) : null,
                <p>{formatPrice(item.price)}</p>,
              ]}
            />
          );
        })}
      </List>
    </Flex>
  );
};
